import { Controller } from "@hotwired/stimulus";

// Drawer lateral deslizable (panel + backdrop) con bloqueo de scroll del body
// y cierre con tecla Escape.
//
// Uso en HTML:
//   <div data-controller="manage--draw-aside">
//     <button data-action="manage--draw-aside#open">Abrir</button>
//
//     <%= render "layouts/draw_aside" do %>
//       <!-- contenido del panel -->
//     <% end %>
//   </div>

export default class extends Controller {
  static targets = ["panel", "backdrop"];

  open() {
    this.panelTarget.classList.remove("hidden");
    this.panelTarget.classList.add("draw-aside--open");
    if (this.hasBackdropTarget) this.backdropTarget.classList.add("draw-aside-backdrop--open");
    this.panelTarget.setAttribute("aria-hidden", "false");
    document.body.classList.add("draw-aside-body-lock");
  }

  close() {
    this.panelTarget.classList.remove("draw-aside--open");
    this.panelTarget.classList.add("hidden");
    if (this.hasBackdropTarget) this.backdropTarget.classList.remove("draw-aside-backdrop--open");
    this.panelTarget.setAttribute("aria-hidden", "true");
    document.body.classList.remove("draw-aside-body-lock");
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close();
  }

  connect() {
    this._escHandler = this.closeOnEscape.bind(this);
    document.addEventListener("keydown", this._escHandler);
  }

  disconnect() {
    document.removeEventListener("keydown", this._escHandler);
    document.body.classList.remove("draw-aside-body-lock");
  }
}
